<template>
    <div
        v-editable="blok"
        class="l4-multi-column-layout"
        data-test="l4-multi-column-layout"
        :class="layoutClasses"
        :style="layoutStyles"
    >
        <div class="container mx-auto">
            <div class="grid grid-cols-1 md:grid-cols-12">
                <template v-for="slot in blok.content" :key="slot._uid">
                    <div
                        v-if="slot"
                        class="flex slot"
                        :class="[`columns-${slot.columns}`]"
                        :style="`grid-column: span ${slot.columns} / span ${slot.columns}`"
                    >
                        <template v-for="content in slot.content" :key="content._uid">
                            <Component
                                :is="content.component"
                                :blok="content"
                                class="w-full"
                                :class="{
                                    'hide-on-desktop': content.displayOption === 'only-mobile',
                                    'hide-on-mobile': content.displayOption === 'only-desktop',
                                }"
                            />
                        </template>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { IL4MulticolumnLayoutConfig } from '~/types/components/L4MulticolumnLayout';

const props = defineProps<{ blok: IL4MulticolumnLayoutConfig }>();

const layoutStyles = computed(() => ({
    backgroundColor: props.blok.hasBackgroundColor ? props.blok.backgroundColor?.color : null,
    paddingTop: props.blok.paddingTop ? props.blok.paddingTop : null,
    paddingBottom: props.blok.paddingBottom ? props.blok.paddingBottom : null,
}));

const layoutClasses = computed(() => ({
    'hide-on-desktop': props.blok.displayOption === 'only-mobile',
    'hide-on-mobile': props.blok.displayOption === 'only-desktop',
}));
</script>

<style scoped lang="postcss">
.container {
    @apply mx-auto px-4 md:px-0;
}

.l4-multi-column-layout {
    &.hide-on-mobile {
        @apply hidden md:block;
    }
    &.hide-on-desktop {
        @apply block md:hidden;
    }

    .slot {
        @apply max-md:col-auto !important;
    }
}
</style>
